import Typography from "@mui/material/Typography";

import * as Constants from "../../config/constants/Constants.js";
import { useLanguage } from "../../config/language/language.js";

export default function Copyright() {
    const LANG = useLanguage();

    return (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: 4, pb: 4 }} style={{ whiteSpace: "pre-line" }}>
            {LANG.COPYRIGHT} {new Date().getFullYear()}
            {".\n"}
            {Constants.PAGE_VERSION}
        </Typography>
    );
}
